module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAASCAMAAAB7LJ7rAAAAAXNSR0IArs4c6QAAAH5QTFRFAAAA////mZnMqqqqkpK2kra2pKS2paW0qqqqpaWtoqKqoqqyoKivpaWso6qxpKivpKetoqiupaevo6iupKeuo6awo6iwo6ixo6iuoqeuoqavo6ewoqavoqevoqevoaauoqevoqevo6auoqauoqavoqauoqauoqauo6evoqau+B7uwQAAACl0Uk5TAAEFBgcHDhESHyEhIyUnSVFYXV5lZ2dvcpevtLvIyc/c3uDt7vv8/f6d6bh0AAAAjElEQVQoz2NgIAUwcbIz4pblllKUF8AtK6OpqakmzIpdlk9GQ1NdQ1NFDKs8nxxQqzjQABUhHCYDJcCKhFiwmawiyoLEwDAZookb03wUIQzz0QxE56IrRzEMi2VIGrA7FSbII4vVo2AjBRkYJFSxBxPIfAUGBn5FJREWrIEsrSzJwMDMxcWMPYo4eNkAqLsS+rkjmkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticket_up.png
// module id = cEWe
// module chunks = 0